const centerRouter = () => {
    return [
        {
            path: 'center',
            name: 'center',
            component: () => import(/* webpackChunkName: "center" */'../../modules/center/index.vue')
        }, {
            path: 'center/my/:name',
            name: 'centerMy',
            component: () => import(/* webpackChunkName: "center" */'../../modules/center/index.vue')
        }
    ];
};
export default centerRouter;
